import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const RecognizeOrdersProgress = z.object({
  selected: z.number().nullable(),
  concurrency: z.number(),
  started: z.number(),
  completed: z.number(),
  running: z.number(),
  failed: z.number(),
  skipped: z.number(),
});

export const getRecognizeOrdersStatus = unaryRpc({
  name: "getRecognizeOrdersStatus",
  input: z.object({ teamId: zExt.objectId() }),
  output: z
    .object({
      workflowId: z.string(),
      status: z.string(),
      progress: RecognizeOrdersProgress,
    })
    .nullable(),
});
